<template>
  <div>
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="title">
          <span>{{ pkg.name }}</span>
          <span class="caption" v-if="env === 'development'">&nbsp;{{ env }}</span>
        </v-list-item-title>
        <v-list-item-subtitle>
          <span>{{ pkg.description }}</span>
          <span class="caption">&nbsp;v{{ pkg.version }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-divider></v-divider>

    <v-list nav>
      <v-list-group
        v-for="(item, i) in items"
        :key="i"
        v-model="item.active"
        :prepend-icon="item.icon"
        :no-action="!$store.state.editable"
      >
        <template v-slot:activator>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.title }}
              <span v-if="$store.state.editable">
                <v-btn icon @click="moveItem(items, item, i, -1)" v-if="i > 0"><v-icon>mdi-chevron-double-up</v-icon></v-btn>
                <v-btn icon @click="moveItem(items, item, i, 1)" v-if="i < items.length - 1"><v-icon>mdi-chevron-double-down</v-icon></v-btn>
                <v-btn icon @click="openDialogItem(i)"><v-icon>mdi-pencil</v-icon></v-btn>
              </span>
            </v-list-item-title>
          </v-list-item-content>
        </template>

        <v-list-item
          v-for="(subItem, j) in item.subItems"
          :key="j"
          :to="$store.state.editable ? null : subItem.to"
          exact
        >
            <!-- <v-list-item-avatar><v-icon>mdi-home-assistant</v-icon></v-list-item-avatar> -->
          <v-list-item-content>
            <v-list-item-title :class="$store.state.editable ? 'pl-4':''">
              {{ subItem.title }}
              <span v-if="$store.state.editable">
                <v-btn icon @click="moveItem(item.subItems, subItem, j, -1)" v-if="j > 0"><v-icon>mdi-chevron-double-up</v-icon></v-btn>
                <v-btn icon @click="moveItem(item.subItems, subItem, j, 1)" v-if="j < item.subItems.length - 1"><v-icon>mdi-chevron-double-down</v-icon></v-btn>
                <v-btn icon @click="openDialogSubItem(i, j)"><v-icon>mdi-pencil</v-icon></v-btn>
              </span>
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="$store.state.editable">
            <v-btn icon :to="subItem.to" exact><v-icon>mdi-arrow-right-bold-circle-outline</v-icon></v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-list-item @click="openDialogSubItem(i, -1)" v-if="$store.state.editable">
          <v-list-item-icon :class="$store.state.editable ? 'pl-4':''">
            <v-icon>mdi-plus</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>추가하기</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list-group>
      <v-list-item @click="openDialogItem(-1)" v-if="$store.state.editable">
        <v-list-item-icon><v-icon>mdi-plus</v-icon></v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>추가하기</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-dialog v-model="dialogItem" max-width="400">
      <v-form v-model="validItem" ref="formItem">
        <v-card>
          <v-card-title>
            메인 아이템 수정
            <v-spacer/>
            <v-btn @click="saveItem" icon color="success"><v-icon>mdi-content-save</v-icon></v-btn>
            <v-btn @click="removeItem" icon color="error" v-if="selectedItemIndex >= 0"><v-icon>mdi-delete</v-icon></v-btn>
            <v-btn @click="dialogItem=false" icon><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="2">
                <v-icon v-text="formItem.icon" :rules="nameRules" required></v-icon>
              </v-col>
              <v-col cols="10">
                <v-text-field
                  v-model="formItem.icon"
                  label="mdi icon"
                  outlined
                  clearable
                  :rules="nameRules"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
            <v-text-field v-model="formItem.title" label="아이템 이름" outlined hide-details></v-text-field>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialogSubItem" max-width="400">
      <v-form v-model="validSubItem" ref="formSubItem">
        <v-card>
          <v-card-title>
            서브 아이템 수정
            <v-spacer/>
            <v-btn @click="saveSubItem" icon color="success"><v-icon>mdi-content-save</v-icon></v-btn>
            <v-btn @click="removeSubItem" icon color="error" v-if="selectedSubItemIndex >= 0"><v-icon>mdi-delete</v-icon></v-btn>
            <v-btn @click="dialogSubItem=false" icon><v-icon>mdi-close</v-icon></v-btn>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="4">
                <v-select v-model="formSubItem.toCategory" :items="categories" label="종류" outlined ></v-select>
              </v-col>
              <v-col cols="8">
                <v-text-field v-if="formSubItem.toCategory" v-model="formSubItem.toContent" label="경로" outlined :rules="nameRules" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field v-model="formSubItem.title" label="메뉴 이름" outlined :rules="nameRules" required></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-chip color="info">{{toJoin}}</v-chip>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>
<script>
import { name, description, version } from '../../../package'

export default {
  props: ['items'],
  data () {
    return {
      env: process.env.NODE_ENV,
      pkg: { name, description, version },
      loading: false,
      validItem: false,
      dialogItem: false,
      formItem: {
        icon: 'mdi-crosshairs-question',
        title: ''
      },
      selectedItemIndex: 0,
      validSubItem: false,
      dialogSubItem: false,
      formSubItem: {
        toCategory: 'page',
        toContent: '',
        title: ''
      },
      categories: [
        { value: '', text: '홈' },
        { value: 'page', text: '페이지' },
        { value: 'board', text: '게시판' },
        { value: 'game', text: '게임' },
        { value: 'admin', text: '관리자' }
      ],
      selectedSubItemIndex: 0,
      nameRules: [
        v => !!v || '빈 문자는 안되요',
        v => (v && v.length <= 30) || '30글자 이상은 안되요'
      ]
    }
  },
  computed: {
    toJoin () {
      let to = '/'
      if (this.formSubItem.toCategory) {
        to += this.formSubItem.toCategory
        if (this.formSubItem.toContent) to += '/' + this.formSubItem.toContent
      }

      return to
      // return `/${this.formSubItem.toCategory}/${this.formSubItem.toContent}`
    }
  },
  methods: {
    async save () {
      if (this.dialogItem && !this.$refs.formItem.validate()) return
      if (this.dialogSubItem && !this.$refs.formSubItem.validate()) return
      try {
        this.loading = true
        const uid = this.$store.state.fireUser ? this.$store.state.fireUser.uid : 'default'
        await this.$firebase.database().ref().child('sites').child(uid).child('menu').set(this.items)
      } catch (e) {
        this.$toast.error(e.message)
      } finally {
        this.dialogItem = false
        this.dialogSubItem = false
        this.loading = false
      }
    },
    openDialogItem (index) {
      this.selectedItemIndex = index
      if (index < 0) {
        if (this.$refs.formItem) this.$refs.formItem.resetValidation()
        this.formItem.icon = 'mdi-crosshairs-question'
        this.formItem.title = ''
      } else {
        this.formItem.icon = this.items[index].icon
        this.formItem.title = this.items[index].title
      }
      this.dialogItem = true
    },
    async saveItem () {
      if (this.selectedItemIndex < 0) this.items.push(this.formItem)
      else {
        this.items[this.selectedItemIndex].icon = this.formItem.icon
        this.items[this.selectedItemIndex].title = this.formItem.title
      }
      this.save()
    },
    async removeItem () {
      this.items.splice(this.selectedItemIndex, 1)
      this.save()
    },
    openDialogSubItem (index, subIndex) {
      this.selectedItemIndex = index
      this.selectedSubItemIndex = subIndex
      if (subIndex < 0) {
        if (this.$refs.formSubItem) this.$refs.formSubItem.resetValidation()
        this.formSubItem.toCategory = 'page'
        this.formSubItem.toContent = ''
        this.formSubItem.title = ''
      } else {
        this.formSubItem.title = this.items[index].subItems[subIndex].title
        const ts = this.items[index].subItems[subIndex].to.split('/')
        if (ts.length < 2) this.formSubItem.toCategory = ''
        else this.formSubItem.toCategory = ts[1]
        if (ts.length < 3) this.formSubItem.toContent = ''
        else this.formSubItem.toContent = ts[2]
      }
      this.dialogSubItem = true
    },
    async saveSubItem () {
      if (this.selectedSubItemIndex < 0) {
        if (!this.items[this.selectedItemIndex].subItems) this.items[this.selectedItemIndex].subItems = []
        this.items[this.selectedItemIndex].subItems.push({ to: this.toJoin, title: this.formSubItem.title })
      } else {
        // if (this.selectedItemIndex === 0 && this.selectedSubItemIndex === 0) {
        //   if (this.formSubItem.to !== '/') throw Error('홈은 변경할 수 없습니다.')
        // }
        this.items[this.selectedItemIndex].subItems[this.selectedSubItemIndex].to = this.toJoin
        this.items[this.selectedItemIndex].subItems[this.selectedSubItemIndex].title = this.formSubItem.title
      }
      this.save()
    },
    async removeSubItem () {
      if (this.selectedItemIndex === 0 && this.selectedSubItemIndex === 0) throw Error('홈은 지울수 없습니다.')
      this.items[this.selectedItemIndex].subItems.splice(this.selectedSubItemIndex, 1)
      this.save()
    },
    moveItem (items, item, i, arrow) {
      items.splice(i + arrow, 0, ...items.splice(i, 1))
      this.save()
    }
  }
}
</script>
